export default "__VITE_ASSET__DaoA87WI__"